// hooks
import { usePushWebSettingsStore } from '../storage/settings';

export const sendPushDataToMarketplace = async (data: object, token: string) => {
  try {
    const configurationJaiminho = usePushWebSettingsStore.getState();
    if (configurationJaiminho.settings.marketplaceApi === '') {
      return console.error('Push web: Api not defined.');
    }

    const headers: { [x: string]: string } = {
      'Content-Type': 'application/json',
    };

    headers['Authorization'] = `Bearer ${token}`;

    await fetch(`${configurationJaiminho.settings.marketplaceApi}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });
  } catch (error) {
    console.error('Push Web: Send push data', error);
  }
};
